import React from 'react';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type TestimonialsProps = {
  items: Testimonial[];
  heading?: string;
  headingId?: string;
  background?: 'paper' | 'white';
};
export function Testimonials({
  items,
  heading,
  headingId,
  background = 'paper'
}: TestimonialsProps) {
  return <section aria-labelledby={headingId} aria-label={heading ? undefined : 'What yoga teachers say'} className={`w-full ${background === 'white' ? 'bg-white' : 'bg-paper'}`} data-id="element-281" data-mp="3ayhypgusrboo">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-16" data-id="element-282" data-mp="321zauj1fadyy">
        {heading && <h2 id={headingId} className="mx-auto mb-10 max-w-2xl text-center font-serif text-2xl font-semibold leading-snug text-ink sm:text-3xl" data-id="element-283" data-mp="2x2w48u5snzov">
            {heading}
          </h2>}

        <ul className="grid grid-cols-1 gap-4 lg:grid-cols-3" data-id="element-284" data-mp="qalj3y2dn7ty">
          {items.map(person => <li key={person.id} className="flex h-full flex-col rounded-2xl border border-sage/15 bg-white p-5 shadow-card sm:p-6" data-id="element-285" data-mp="h67wpwq6ta6o">
              <div className="flex items-center gap-3.5" data-id="element-286" data-mp="m2om0u94hulc">
                <img src={person.photo} alt={`${person.name}, yoga teacher`} width={112} height={112} className="h-14 w-14 shrink-0 rounded-full object-cover" loading="lazy" decoding="async" data-id="element-287" data-mp="7928cw8yjxa5" />
                <div className="min-w-0" data-id="element-288" data-mp="14xlp22oc95rn">
                  <div className="flex gap-0.5" aria-label="Five out of five stars" data-id="element-289" data-mp="q7eiolblvd7b">
                    {Array.from({
                  length: 5
                }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-brass text-brass" strokeWidth={0} aria-hidden="true" data-id="element-290" data-mp="v3mrlgz7ma61" data-mpi={index} />)}
                  </div>
                  <p className="mt-1.5 font-sans text-[14px] font-semibold leading-tight text-ink" data-id="element-291" data-mp="1xh7nyucry8qj">
                    {person.name}
                  </p>
                  <p className="font-sans text-[12px] leading-tight text-ink-soft" data-id="element-292" data-mp="1ogj9jyjgy6d4">
                    {person.credential}
                  </p>
                </div>
              </div>

              <blockquote className="mt-4 font-sans text-[15px] leading-[1.6] text-ink-soft" data-id="element-293" data-mp="1ejoejpmemo3l">
                {person.quote}
              </blockquote>
            </li>)}
        </ul>
      </div>
    </section>;
}